webpackJsonp([18040708913748],{

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Nick-Tune.b7fed621.jpg";

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NickTune = __webpack_require__(118);
	
	var _NickTune2 = _interopRequireDefault(_NickTune);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NickTune = function NickTune() {
	  return _react2.default.createElement(
	    'section',
	    { id: 'speaker', className: 'parallax-section' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 col-sm-12 wow fadeInUp', 'data-wow-delay': '0.1s' },
	          _react2.default.createElement(
	            'div',
	            { className: 'team-wrapper' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Nick Tune'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement('img', { src: _NickTune2.default, className: 'img-responsive', alt: 'Nick Tune' }),
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'social-icon' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement('a', { href: 'https://www.linkedin.com/in/nick-tune-3671441a/', target: '_blank', className: 'fa fa-linkedin wow fadeIn' })
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement('a', { href: 'https://twitter.com/ntcoding', target: '_blank', className: 'fa fa-twitter wow fadeIn' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-5' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Nick Tune is a strategic technical leader at Navico. He has a passion for delighting users, creating business impacts, crafting quality software, and building world-class engineering teams. He\u2019s the coauthor of two books, Patterns, Principles and Practices of Domain-Driven Design (Wrox) and Designing Autonomous Teams and Services (O\u2019Reilly), and frequently blogs about technical leadership at ',
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://www.ntcoding.co.uk', target: '_blank' },
	                    'ntcoding.co.uk'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                'Talk: Sociotechnical domain-driven design: Aligning teams and software for continuous delivery'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'A loosely coupled software architecture and an organizational structure to match is one of the biggest predictors of continuous delivery performance. To optimize end-to-end value creation and delivery, technical leaders must adopt a sociotechnical mindset.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'When teams are designed without consideration of the software architecture, dependencies will arise in code that inhibit teams from delivering high value at speed. Organizational dysfunctions will multiply as productivity and motivation drop dramatically across the entire company. But by adopting a sociotechnical mindset, teams and software systems can be aligned to minimize dependencies and maximize product innovation speed.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'The sociotechnical mindset is the synthesis of multiple perspectives, including social dynamics, domain-driven design, business models, and software architecture. Nick Tunee teaches you how to apply these principles and patterns through real examples based on years of practical experience across a wide range of organizations, including the UK government, Salesforce, and more.'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = NickTune;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-speakers-nick-tune-js-17bc6abdb6791af5df9b.js